import { useHistoryChange } from '@app/components-legacy/Router/hooks'
import { useAppRouter, useStores } from '@app/hooks'
import { router } from '@libs/Router/router'

/**
 * Set the router object into AppRouter.
 */
export function useRouterInit(): void {
  const appRouter = useAppRouter()
  const { storeLayout } = useStores()

  useHistoryChange({
    onHistoryChange: () => {
      storeLayout.setCurrentPathname(document.location.pathname)
    }
  })

  appRouter.setRouter(router)
}
